import { render, staticRenderFns } from "./ModalAdmissionTeamMembers.vue?vue&type=template&id=294f3a88&"
import script from "./ModalAdmissionTeamMembers.vue?vue&type=script&lang=js&"
export * from "./ModalAdmissionTeamMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports